import { LanguageProps } from "../types/LanguageProps";

export const setLocaleCookie = ({ locale }: { locale: LanguageProps["locale"] }): void => {
    document.cookie = `i18next=${locale}`;
};
